import { TLBaseShape, RecordProps, T, HTMLContainer, BaseBoxShapeUtil } from "@tldraw/tldraw";

type RedLineUtilType = TLBaseShape<
  "redLine",
  {
    w: number;
    h: number;
    isDoorHanger?: boolean;
    isFront?: boolean;
  }
>;

export class RedLineUtil extends BaseBoxShapeUtil<RedLineUtilType> {
  static type = "redLine" as const;
  static props: RecordProps<RedLineUtilType> = {
    w: T.number,
    h: T.number,
    isDoorHanger: T.optional(T.boolean),
    isFront: T.optional(T.boolean),
  };

  isAspectRatioLocked(_shape: RedLineUtilType): boolean {
    return true;
  }

  getDefaultProps(): { w: number; h: number } {
    return {
      w: 0,
      h: 0,
    };
  }
  component(shape: RedLineUtilType) {
    const { isDoorHanger, isFront, w, h } = shape.props;
    const d =
      "M241 1.0082C241 1.01642 241 0.999983 241 1.0082ZM241 1.0082L241 64.6399C241 65.0519 240.808 65.442 240.477 65.7018C236.011 69.2145 231.24 72.4557 226.165 75.1299C218.196 79.3326 209.811 82.87 200.671 84.9928C200.614 85.0065 200.558 85.0165 200.5 85.0219C198.901 85.1979 197.358 85.4503 195.685 85.6755C194.05 85.896 192.357 86.0793 190.64 86.0793M241 1.0082L0.999992 0.999983V561L241 560.922V110.459C241 110.041 240.802 109.644 240.462 109.384C235.99 105.969 231.233 102.872 226.165 100.198M226.208 100.221C218.169 95.625 209.771 92.4494 200.672 90.333C200.663 90.3312 200.655 90.3294 200.646 90.3276C197.325 89.6166 194.025 89.2547 190.797 88.9093C187.455 88.552 184.125 88.552 180.784 88.9093M180.812 88.9066C172.493 89.6348 165.349 93.6626 160.114 99.4595C160.058 99.5214 160.008 99.588 159.965 99.6582C158.947 101.303 157.577 102.971 156.124 104.715C156.083 104.764 156.045 104.817 156.011 104.872C155 106.509 153.64 108.159 152.275 109.469C152.224 109.519 152.176 109.573 152.132 109.63C147.275 116.013 140.692 120.697 132.744 123.04C132.739 123.042 132.733 123.043 132.727 123.045C125.101 125.392 116.777 125.392 109.159 123.045C109.153 123.043 109.148 123.042 109.142 123.04C101.216 120.706 94.6338 115.695 89.7443 109.282M89.7443 109.283C84.9009 102.919 82.4713 95.5584 82.4713 87.4902C82.4713 79.7601 84.8962 72.0556 89.7443 65.6981V65.6972C94.6017 59.316 101.195 54.6148 109.195 51.9241M109.159 51.9351C116.787 49.5881 125.11 49.5881 132.727 51.9351C132.733 51.9369 132.739 51.9387 132.744 51.9405C140.702 54.283 147.274 58.967 152.132 65.3509C152.143 65.3645 152.154 65.3791 152.166 65.3919C153.729 67.2905 154.99 68.479 156.016 70.116C156.047 70.1661 156.082 70.2135 156.119 70.2599C157.571 72.0209 158.948 73.6861 159.966 75.3249C160.002 75.3824 160.042 75.437 160.086 75.4899C165.359 81.6915 172.523 85.3219 180.748 86.4129C180.811 86.422 180.876 86.4256 180.94 86.4256C184.164 86.4256 187.469 86.4275 190.797 86.0711";

    return (
      <HTMLContainer
        style={{
          border: isDoorHanger ? undefined : "1px dashed red",
        }}
      >
        {isDoorHanger && isFront ? (
          <svg width={w} height={h} viewBox="0 0 242 560" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d={d} stroke="red" stroke-linecap="butt" strokeDasharray={"4 4"} />
          </svg>
        ) : null}
        {isDoorHanger && !isFront ? (
          <svg
            width={w}
            height={h}
            viewBox="0 0 242 560"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: "scaleX(-1)" }}
          >
            <path d={d} stroke="red" stroke-linecap="butt" strokeDasharray={"4 4"} />
          </svg>
        ) : null}
      </HTMLContainer>
    );
  }
  indicator(shape: RedLineUtilType) {
    return this.component(shape);
  }
}
